import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
// import ReactPlayer from "react-player";
import VideoPlayer from "react-video-js-player";

var list = [
  { id: 1, url: "/video/EMC1.mp4" },
  { id: 2, url: "/video/EMC1.mp4" },
];

const Pass = () => {
  const params = useParams();
  const history = useHistory();
  const [url, setUrl] = useState();

  useEffect(() => {
    if (params.id) {
      var item = list.find((a) => a.id === parseInt(params.id));
      setUrl(item.url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id, url]);

  return (
    <>
      {/* <ReactPlayer
        controls
        url="https://www.youtube.com/watch?v=7sDY4m8KNLc"
      ></ReactPlayer> */}
      {/* <video autoPlay>
        <source src="/video/EMC1.mp4" type="video/mp4" />
      </video> */}
      <div className="card">
        <div className="card-header border-bottom">
          <button
            className="btn btn-outline-secondary"
            type="button"
            style={{ float: "left" }}
            onClick={() => {
              history.goBack();
            }}
          >
            <i
              className="icon ion-ios-arrow-back"
              style={{ display: "block" }}
            />
          </button>
        </div>
        <div className="card">
          <div className="card-header">Гар утаснаас нууц үгээ солих заавар</div>

          <div className="card-body">
            <VideoPlayer src="/video/sso.mp4" width="860"></VideoPlayer>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(Pass);
